import request from '@/utils/request'

let Real_estateApi = {

  /*房产列表*/
  list(data) {
    return request._post('/shop/plus.real_estate.Index/index', data);
},
/*添加房产*/
add(data) {
    return request._post('/shop/plus.real_estate.Index/add', data);
},
/*修改房产*/
edit(data) {
    return request._post('/shop/plus.real_estate.Index/edit', data);
},
/*删除房产*/
del(data) {
    return request._post('/shop/plus.real_estate.Index/del', data);
},
/*房产详情*/
detail(data) {
  return request._post('/shop/plus.real_estate.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.real_estate.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.real_estate.Setting/getSetting', data, errorback);
    },
}
export default Real_estateApi;



// WEBPACK FOOTER //
// ./src/api/real_estate.js